<script>
import Multiselect from "vue-multiselect";
import LocationService from "@/MainServices/LocationService.js";
import IndexService from "@/MainServices/IndexService.js";
import Navbar from "@/view/front/components/navbar";
import Footer from "@/view/front/components/footer";
import CourseFilter from "@/view/front/components/course_filter";
import { ArrowUpIcon, HeartIcon, EyeIcon, ShoppingCartIcon } from "vue-feather-icons";
import Skeleton from "@/view/front/components/skeleton";
import Course from "@/view/front/components/course";

export default {
  components: { 
    // Multiselect,
    Navbar, 
    Footer, 
    CourseFilter, 
    // ArrowUpIcon, 
    // Skeleton, 
    // Course 
    },
  data() {
    return {};
  },
  methods: {},
  mounted() {},
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<template>
  <div>
    <Navbar />

    <!-- Hero Start -->
    <section class="d-table w-100">
      <div class="main_top_courses_page_bg_hero">
        <div class="container">
          <div class="row justify-content-center">
            <div class="col-lg-12 text-center">
              <div class="page-next-level">
                <h4 class="courses-page-top-im-title"> <span style="color: #2eca8b">my</span>Courses</h4>
                <p class="courses-page-top-im-ptext">Select from your favourite <span style="color: #2eca8b">Courses</span> and <br> apply at your ease.</p>
                <div class="page-next"></div>
              </div>
            </div>
            <!--end col-->
          </div>
          <!--end row-->
        </div>
        <!--end container-->
      </div>
    </section>
    <!--end section-->
    <div class="position-relative" style="margin-bottom: 3rem;">
      <div class="shape overflow-hidden text-white">
        <svg viewBox="0 0 2880 48" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M0 48H1437.5H2880V0H2160C1442.5 52 720 0 720 0H0V48Z"
            fill="currentColor"
          ></path>
        </svg>
      </div>
    </div>
    <!-- Hero End -->


    <CourseFilter />
    <Footer />
    <!-- Footer End -->
    <!-- Back to top -->
    <a
      href="javascript: void(0);"
      class="btn btn-icon btn-soft-primary back-to-top"
      id="back-to-top"
      v-scroll-to="'#topnav'"
    >
      <arrow-up-icon class="icons"></arrow-up-icon>
    </a>
    <!-- Back to top -->
  </div>
</template>

<style>
</style>
